<script>
  import Label from "./Label.svelte";
  import { nanoid } from "nanoid";
  import clsx from "clsx";

  let className = "my-4";
  export { className as class };
  export let options;
  export let label;
  export let value;
  export let placeholder;
  export let required = false;
  export let valueKey = "value";
  export let labelKey = "label";
  export let placeholderValue = "";

  const id = "select-" + nanoid();

  const isArray = Array.isArray(options);
</script>

<div class={clsx(className, "not-prose")}>
  <Label {id} {label} {required} />
  <select {id} class="form-select w-full" {required} bind:value>
    {#if placeholder}
      <option value={placeholderValue} disabled>{placeholder}</option>
    {/if}
    {#if isArray}
      {#each options as item}
        <option value={item[valueKey]} disabled={item[valueKey] == placeholderValue}>{item[labelKey] || item[valueKey]}</option>
      {/each}
    {:else}
      {#each Object.keys(options) as value}
        <option {value} disabled={value == placeholderValue}>{options[value]}</option>
      {/each}
    {/if}
  </select>
</div>
